import {HTTP_ALB, HTTP_YAF} from '../axios';

//	员工列表
export const staffList = params => {
	return HTTP_ALB.get('/foundation/staff/list', params);
};
//	员工添加
export const staffAdd = params => {
	return HTTP_ALB.post('/foundation/staff/add', params);
};
//	员工修改
export const staffEdit = params => {
	return HTTP_ALB.post('/foundation/staff/edit', params);
};
//	员工删除
export const staffDel = params => {
	return HTTP_ALB.get('/foundation/staff/del', params);
};


